// extracted by mini-css-extract-plugin
export default {"container":"StudySettings_container__dQoGL","options":"StudySettings_options__4tVWo"};